<template>
  <div v-if="dispositif">
    <div class="mgt-20px">
      <div class="level mgt-20px is-align-items-flex-start">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{$t('dispositifPublicitaire.detail', { code: dispositif.code }) }}
                <b-tag v-if="!dispositif.actif"
                  type="has-background-subMenu"
                  class="has-text-white mgl-5px">
                  {{$t('dispositifPublicitaire.archive')}}
                </b-tag>
                <tag-list class="mg-5px"
                  v-if="tags.length > 0"
                  :listes="tags"/>
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right mgt-10px">
          <div class="buttons">
            <dropdownButton
                type="is-addOrEdit"
                class="mgr-2"
                :permission="permEmplacement.maj"
                :actions="actionSecondary"
                @click="goToModif">
                  {{$t('general.button.edit') }}
            </dropdownButton>
            <b-dropdown class="button is-bottom-left has-text-left">
              <div slot="trigger" class="right">
                <b-icon icon="call-split" type="is-default" class="mgt-5px"></b-icon>
                <b-icon icon="chevron-down" class="has-text-default"></b-icon>
              </div>
              <b-dropdown-item class="pdl-20px">
                <p class="has-text-icon-more is-size-7">
                  {{$t('dispositifPublicitaire.titleAccesRapide')}}
                </p>
              </b-dropdown-item>
              <b-dropdown-item class="is-paddingless"
                              v-for="(accesRapide, index) in genererAllAccesRapide" :key="index">
                <router-link-blank :to="{ name: accesRapide.name,
                                      params: accesRapide.params}"
                                  class="pdt-5px pdb-5px"
                                  classMessage="has-text-default is-size-6 is-block
                                    mgl-20px mgr-20px"
                                  classComposant="noTextDecoration"
                                  :message="accesRapide.libelle">
                </router-link-blank>
              </b-dropdown-item>
            </b-dropdown>
            <piece-jointe-button
              class="mgr-2"
              :perm="permEmplacement.maj"
              autoSave>
            </piece-jointe-button>
          </div>
        </div>
      </div>
      <informations-generation-code-dispositif class="mgt-20px"
                                               :element="dispositif"
                                               :emplacement="dispositif.emplacement"
                                               :tree-link="true"
      />
      <div class="tab  mgh-0">
        <ul>
          <li :class="{'is-active': activeTab === 'InfoGenerale'}"
            @click="activeTab = 'InfoGenerale'">
            {{ $t('dispositifPublicitaire.infoGeneral') }}
          </li>
          <li :class="{'is-active': activeTab === 'ListeMateriels'}"
              @click="activeTab = 'ListeMateriels'">
            {{ $t('emplacement.tab.materiel') }}
          </li>
          <li :class="{'is-active': activeTab === 'InfoTechnique'}"
            @click="activeTab = 'InfoTechnique'">
            {{ $t('dispositifPublicitaire.infoTechnique') }}
          </li>
          <li :class="{'is-active': activeTab === 'ListeOtTechnique'}"
              v-if="afficherLogistique"
              @click="activeTab = 'ListeOtTechnique'">
            {{ $t('adresseEmplacement.otTechnique') }}
          </li>
          <li :class="{'is-active': activeTab === 'InfoMobilier'}"
              @click="activeTab = 'InfoMobilier'">
            {{ $t('dispositifPublicitaire.infoMobilier') }}
          </li>
          <li :class="{'is-active': activeTab === 'NomenclatureTechnique'}"
            @click="activeTab = 'NomenclatureTechnique'">
            {{ $t('nomenclatureTechnique.title') }}
          </li>
          <li :class="{'is-active': activeTab === 'listeEtatHistorique'}"
            @click="activeTab = 'listeEtatHistorique'">
            {{ $t('patrimoine.patrimoineEtatHistorique.title') }}
          </li>
        </ul>
      </div>
      <div>
        <component
          :showPerPage="true"
          :idPatrimoine="dispositif.id"
          :is="activeTab"
          :typePatrimoine="constantes.DISPOSITIF"
          :ids="idsOfPatrimoine"
          :dispositifPublicitaire="dispositif"
          :dispositifTechnique="dispositif.dispositifTechnique"
          :dispositifAccessoires="dispositif.dispositifAccessoires"
          :data="dispositif"
          :isPatrimoine="true"
          :item="dispositif"
          :disabled="true"
        />
      </div>
    </div>
    <b-modal v-model="openPopUpPrevention"
             has-modal-card
             class="modal">
      <pop-up-prevention
        v-if="dispositif"
        @no="openPopUpPrevention = false"
        @yes="archiverDispositif"
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :mess-header="$t(('dispositifPublicitaire.archivageDesarchiver.'
        + (dispositif.actif ? 'archivage' : 'desarchivage')))"
        :mess-footer="$t(('dispositifPublicitaire.infoArchivageDesarchivage.'
        + (dispositif.actif ? 'archivage' : 'desarchivage')))">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="popUpDupliquer" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="$t('dispositifPublicitaire.popUpPreventionCopy.message')"
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        :messagesChampsVide="messagesChampsVide"
        :champsVide="champsVide"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @yes="dupliquerDispositif"
        @no="popUpDupliquer = false"
      />
    </b-modal>
    <b-modal v-model="openPopUpPreventionSuppression"
             has-modal-card
             class="modal">
      <pop-up-prevention
        v-if="dispositif"
        @no="openPopUpPreventionSuppression = false"
        @yes="supprimerDispositif"
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :mess-header="$t('dispositifPublicitaire.supprimer.titre')"
        :mess-footer="$t('dispositifPublicitaire.supprimer.sousTitre')">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import dropdownButton from '@/components/general/button/dropdownButton';
import { EMPLACEMENT } from '@/configuration/gabed/permissionsGabedConf';
import {
  get,
  archiver,
  dupliquerAsync,
  supprimer,
} from '@/api/gabed/dispositif';
import messageErreur from '@/services/general/messageErreur';
import InfoMobilier from '@/components/gabed/dispositif/c_infoMobilier';
import InfoTechnique from '@/components/gabed/dispositif/c_infoTechnique';
import InfoGenerale from '@/components/gabed/dispositif/c_infoGenerale';
import messageSucces from '@/services/general/messageSucces';
import validationDispositif from '@/services/gabed/dispositif/validation';
import popUpPrevention from '@/components/general/popUpPrevention';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import ListeOtTechnique from '@/components/emplacementTechnique/listeOtTechnique';
import {
  DISPOSITIF,
  PARKING,
  ADRESSE,
  CENTRE_COMMERCIAL,
  LIGNE_BUS,
  CLIENT,
} from '@/configuration/gabed/emplacement/emplacementConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import NomenclatureTechnique from '@/components/commun/nomenclature/nomenclatureTechnique';
import breadcrumb from '@/components/general/breadcrumb';
import tagList from '@/components/general/tagList';
import ListeMateriels from '@/components/gabed/dispositif/l_materielsDispositif';
import informationsGenerationCodeDispositif from '@/components/gabed/dispositif/informationsGenerationCodeDispositif';
import validationPatrimoine from '@/services/gabed/patrimoine/validationPatrimoine';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/gabed/emplacement/validation/champsEmplacementTranslator';
import validationSuppression from '@/services/gabed/dispositif/validationSuppression';
import listeEtatHistorique from '@/components/patrimoineEtatHistorique/l_patrimoineEtatHistorique';

const permissions = createNamespacedHelpers('permissions');
const Attachments = createNamespacedHelpers('attachments');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'c_dispositifPublicitaire',
  data() {
    return {
      dispositif: null,
      permEmplacement: EMPLACEMENT,
      activeTab: 'InfoGenerale',
      errorPopUp: false,
      openPopUpPrevention: false,
      messagesErreurPopUp: [],
      idsOfPatrimoine: [],
      constantes: {
        DISPOSITIF,
      },
      popUpDupliquer: false,
      champsVide: [],
      messagesChampsVide: [],
      openPopUpPreventionSuppression: false,
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    InfoTechnique,
    InfoMobilier,
    dropdownButton,
    InfoGenerale,
    popUpPrevention,
    ListeOtTechnique,
    routerLinkBlank,
    pieceJointeButton,
    NomenclatureTechnique,
    tagList,
    ListeMateriels,
    informationsGenerationCodeDispositif,
    listeEtatHistorique,
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    actionSecondary() {
      const actions = [
        {
          label: this.$t('general.button.' + (this.dispositif.actif ? 'archiver' : 'desarchiver')),
          action: () => { this.openPopUpPrevention = true; },
          permissionAction: EMPLACEMENT.supprimer,
          disabled: this.disableDesarchiver,
        },
        {
          label: this.$t('general.button.dupliquer'),
          action: () => { this.popUpDupliquer = true; },
          permissionAction: EMPLACEMENT.maj,
        },
        {
          label: this.$t('general.button.delete'),
          action: () => {
            this.errorPopUp = false;
            this.messagesErreurPopUp = [];
            this.openPopUpPreventionSuppression = true;
          },
          permissionAction: EMPLACEMENT.supprimer,
        },
      ];

      return actions;
    },
    afficherLogistique() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.afficherLogistiqueTechnique.key);
    },
    breadcrumb() {
      return [
        { title: this.$i18n.t('listeClients.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('emplacement.title'), route: { name: 'l.gabed.emplacement' }, isActive: false },
        {
          title: this.$i18n.t('detailEmplacement.titleWithoutN'),
          route: { name: 'c.gabed.emplacement-detailEmplacement', params: { id: this.dispositif.emplacementId } },
          isActive: false,
        },
        { title: this.$i18n.t('dispositifPublicitaire.detailWithoutCode'), route: '', isActive: true },
      ];
    },
    disableDesarchiver() {
      return !this.dispositif.actif && !this.dispositif.emplacement.actif;
    },
    genererAllAccesRapide() {
      const accesRapides = [];
      if (this.dispositif) {
        accesRapides.push(
          { name: 'l.baux.contrat-by-materiel', params: { typePatrimoine: DISPOSITIF, patrimoineId: this.dispositif.id }, libelle: this.$t('dispositifPublicitaire.voirBaux') },
        );
      }
      return accesRapides;
    },
    tags() {
      if (!this.dispositif.tags.length) return [];
      return this.dispositif.tags.map(t => t.tag);
    },
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    getAllIds() {
      const ids = [];
      ids.push(this.dispositif.id);
      this.dispositif.materiels.forEach((materiel) => {
        ids.push(materiel.id);
        materiel.faces.forEach((face) => {
          ids.push(face.id);
        });
      });
      return ids;
    },
    goToModif() {
      this.$router.push({
        name: 'm.gabed.emplacement-dispositifPublicitaireEdition',
        params: { idDispositif: this.dispositif.id },
      });
    },
    async archiverDispositif() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorPopUp = false;
        this.messagesErreurPopUp = [];
        const dispositifArchive = (await archiver(this.dispositif.id, this.dispositif.actif))
          .data.result;
        messageSucces(this.$i18n.t('dispositifPublicitaire.messages.success.' + (this.dispositif.actif ? 'archivage' : 'desarchivage')));
        this.openPopUpPrevention = false;
        this.dispositif.actif = dispositifArchive.actif;
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          validationDispositif(e.response, this.messagesErreurPopUp);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async dupliquerDispositif() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorPopUp = false;
        this.messagesErreurPopUp = [];
        this.champsVide = [];
        this.messagesChampsVide = [];
        const response = (await dupliquerAsync(this.dispositif.id)).data.result;
        messageSucces(this.$t('dispositifPublicitaire.popUpPreventionCopy.success'));
        this.$router.push({
          name: 'c.gabed.emplacement-detailDispositif',
          params: { idDispositif: response.id },
        });
      } catch (e) {
        if (e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide, this.messagesErreurPopUp,
            this.messagesChampsVide, translate);
          validationPatrimoine(e.response, this.messagesErreurPopUp);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    switchDetailEmplacement(emplacement) {
      let routeName = null;
      switch (emplacement.type) {
        case ADRESSE:
          routeName = 'c.gabed.emplacement-adresse';
          break;
        case PARKING:
          routeName = 'c.gabed.emplacement-parking';
          break;
        case CENTRE_COMMERCIAL:
          routeName = 'c.gabed.emplacement-centreCommercial';
          break;
        case LIGNE_BUS:
          routeName = 'c.gabed.emplacement-ligneBus';
          break;
        case CLIENT:
          routeName = 'c.gabed.emplacement-client';
          break;
        default:
          routeName = 'home';
      }
      return routeName;
    },
    async supprimerDispositif() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorPopUp = false;
        this.messagesErreurPopUp = [];
        await supprimer(this.dispositif.id);
        messageSucces(this.$t('dispositifPublicitaire.messages.success.supprimer'));
        this.openPopUpPreventionSuppression = false;
        this.$router.push({
          name: this.switchDetailEmplacement(this.dispositif.emplacement),
          params: { id: this.dispositif.emplacementId },
        });
      } catch (e) {
        if (e.response.data.error) {
          validationSuppression(e.response, this.messagesErreurPopUp);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.afficherLogistiqueTechnique.key]);
      await this.setAttachmentContext({ module: 'Dispositif' });
      await this.setAttachmentElementId({ id: this.$route.params.idDispositif });
      const dispositif = (await get(this.$route.params.idDispositif)).data.result;
      if (dispositif.nomenclature) {
        dispositif.nomenclature = JSON.parse(dispositif.nomenclature);
      }
      this.dispositif = dispositif;
      this.idsOfPatrimoine = this.getAllIds();
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.dispositif.code }));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
